<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <el-form label-position="left"
             :inline="true"
             style="margin-top:20px">
      <el-row class="margb10">
        <el-col class="padt5">
          <!-- 创建人 -->
          <el-form-item label="邮件主题:">
            <el-input placeholder=""
                      style="width:600px"
                      v-model="dataForm.mailTheme"
                      :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <!-- 邮件内容 -->
          <el-form-item label="邮件内容:">
            <el-input placeholder=""
                      style="width:600px"
                      type="textarea"
                      :rows="7"
                      v-model="dataForm.mailContent"
                      :disabled="true"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 附件表格 -->
    <div class="table-user table"
         style="margin-top:8px;">
      <el-table :data="maildataList"
                v-loading="dataListLoading"
                border
                style="width: 100%">
        <!-- 序号 -->
        <el-table-column label="No."
                         width="120"
                         show-overflow-tooltip
                         align="left"
                         type="index"
                         header-align="center">
        </el-table-column>
        <!-- 附件名称 -->
        <el-table-column prop="attachmentName"
                         label="附件名称"
                         show-overflow-tooltip
                         header-align="center">
          <template slot-scope="scope">
            <span class="el-dropdown-link"
                  role="button"
                  tabindex="0"
                  @click="downLoadPage(`${scope.row.mailAttachmentId}`, scope.row.attachmentName)">
              {{ scope.row.attachmentName }}</span>
          </template>
        </el-table-column>
        <!-- 上传时间 -->
        <el-table-column prop="createTime"
                         label="上传时间"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column>
      </el-table>
    </div>
    <!-- 发送人表格 -->
    <div class="table-user table"
         style="margin-top:15px;">
      <el-table :data="dataList"
                v-loading="dataListLoading"
                border
                style="width: 100%">
        <!-- 序号 -->
        <el-table-column label="No."
                         width="120"
                         show-overflow-tooltip
                         align="left"
                         type="index"
                         header-align="center">
        </el-table-column>
        <!-- 公司 -->
        <el-table-column prop="name"
                         label="公司"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column>
        <!-- 姓名 -->
        <el-table-column prop="userName"
                         label="姓名"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column>
        <!-- 职位 -->
        <el-table-column prop="positionName"
                         label="职位"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column>
        <!-- 邮箱 -->
        <el-table-column prop="email"
                         label="邮箱"
                         show-overflow-tooltip
                         header-align="center">
        </el-table-column>
      </el-table>
      <div class="block"
           style="float: right;margin-top: 20px;margin-right: 30px; margin-bottom: 20px">
        <el-pagination @size-change="pageSizeChangeHandle"
                       @current-change="pageCurrentChangeHandle"
                       :current-page="page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="limit"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  data() {
    return {
      // 获取收件人列表信息
      mixinViewModuleOptions: {
        getDataListURL: `/sys/commmail/receiverList?mailId=${this.$route.query.mailId}`,
        getDataListIsPage: true
      },
      dataForm: {},
      userdataList: [],
      maildataList: [],
      dataListLoading: false,
      sendMailId: '',
      mailId: ''
    }
  },
  methods: {
    // 获取所有信息
    getUserList() {
      this.$request.get(`/sys/commmail/sendMailInfo/${this.mailId}`).then((res, total, code, data) => {
        console.log(res)
        this.dataForm = res
        this.userdataList = res.receiver
        this.maildataList = res.attachment
      }).catch((err) => {
        console.log(err)
      })
    },
    // 下载
    downLoadPage(url, name) {
      let upimgurl = `/sys/commmail/downloadAttachment?mailAttachmentId=${url}`
      this.$request.download(upimgurl, name, null, null, 'email')
    }
  },
  activated() {
    if (this.$route.query.mailId !== '' && this.$route.query.mailId !== undefined && this.$route.query.mailId !== null) {
      this.sendMailId = `${this.$route.query.mailId}`
      this.mailId = `${this.$route.query.mailId}`
      this.$request.get(`/sys/commmail/sendMailInfo/${this.mailId}`).then((res, total, code, data) => {
        console.log(res)
        this.dataForm = res
        this.userdataList = res.receiver
        this.maildataList = res.attachment
      }).catch((err) => {
        console.log(err)
      })
    }
    console.log(this.sendMailId)
  }
}
</script>
